import { render, staticRenderFns } from "./PromobarCarousel.vue?vue&type=template&id=c9f15dd4&scoped=true&lang=pug&"
import script from "./PromobarCarousel.vue?vue&type=script&lang=js&"
export * from "./PromobarCarousel.vue?vue&type=script&lang=js&"
import style0 from "./PromobarCarousel.vue?vue&type=style&index=0&id=c9f15dd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f15dd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9f15dd4')) {
      api.createRecord('c9f15dd4', component.options)
    } else {
      api.reload('c9f15dd4', component.options)
    }
    module.hot.accept("./PromobarCarousel.vue?vue&type=template&id=c9f15dd4&scoped=true&lang=pug&", function () {
      api.rerender('c9f15dd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/promobar/PromobarCarousel.vue"
export default component.exports